import { useRef } from 'react';
import { Whisper, IconButton, RadioGroup, Radio } from 'rsuite';
import iconPreference from '../../../../../../assets/icons/icon_preference.svg';
import styles from './FilterPreference.module.scss';
import { LoadingSpinerLocal } from '../../../../../../components/LoadingSpinner';

interface FilterPreferenceProps {
  className?: string;
  tipoPrecoValue: string;
  loading: boolean;
  onChangePriceType: (value: string) => void;
}

export const FilterPreference: React.FC<FilterPreferenceProps> = ({ className, tipoPrecoValue, loading, onChangePriceType }) => {
  const popoverRef = useRef<{ hide: () => void } | null>(null);

  return (
    <Whisper
      placement="bottomEnd"
      trigger="click"
      triggerRef={popoverRef}
      speaker={
        <div className={styles['preference-popover']}>
          <LoadingSpinerLocal loading={loading} size="sm" />
          <div className={styles['form-wrapper']}>
            <p className={styles['popover-title']}>TIPO DE PREÇO</p>
            <RadioGroup name="tipoPreco" onChange={onChangePriceType} value={tipoPrecoValue}>
              <Radio value="PRECO_PAGO">
                <p className={styles['input-title']}>Preço pago</p>
                <p className={styles['input-subtitle']}>Preço efetivamente pago pelo usuário no varejo, podendo ser promoção.</p>
              </Radio>
              <Radio value="PRECO_REGULAR">
                <p className={styles['input-title']}>Preço regular</p>
                <p className={styles['input-subtitle']}>Preço original do produto, sem promoção e outros descontos.</p>
              </Radio>
            </RadioGroup>
          </div>
        </div>
      }
    >
      <IconButton
        className={`${styles['btn-preference']} ${className}`}
        appearance="subtle"
        placement="right"
        icon={<img alt="preferencias" src={iconPreference} />}
      >
        Preferências
      </IconButton>
    </Whisper>
  );
};
